import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';

// import { MainNavComponent } from '../main-nav/main-nav.component';
//import { CommonService } from '../../services/common/common.service';
import { FlexLayoutModule } from '@angular/flex-layout';

// material
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatPaginatorModule } from '@angular/material/paginator';



import { from } from 'rxjs';

export const SharedMaterial = [CommonModule,
  FormsModule,
  MatSelectModule,
  //MainNavComponent,
  MatFormFieldModule,
  MatSnackBarModule,
  MatInputModule,
  MatToolbarModule,
  MatButtonModule,
  MatSidenavModule,
  MatIconModule,
  MatListModule,
  MatCardModule,
  MatGridListModule,
  MatDialogModule,
  MatRadioModule,
  MatDatepickerModule,
  // MatNativeDateModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatTableModule,
  MatMenuModule,
  MatDividerModule,
  MatChipsModule,
  MatProgressBarModule,
  MatTabsModule,
  MatBadgeModule,
  MatExpansionModule,
  MatStepperModule,
  MatTooltipModule,
  MatAutocompleteModule,
  MatBottomSheetModule,
  MatPaginatorModule,
  FlexLayoutModule]
